export const SIMPLERSELL_ATHENA_GRAPHQL_URL = 'https://graphql.simplersell.com/api/graphql';

export function isRecord(value: unknown): value is Record<string, unknown> {
  return Boolean(value && typeof value === 'object' && !Array.isArray(value));
}

export function stringField(record: Record<string, unknown>, field: string) {
  const value = record[field];
  return typeof value === 'string' && value.trim() ? value : undefined;
}

export function numberField(record: Record<string, unknown>, field: string) {
  const value = record[field];
  return typeof value === 'number' && Number.isFinite(value) ? value : undefined;
}

export function stringArrayField(record: Record<string, unknown>, field: string) {
  const value = record[field];
  return Array.isArray(value)
    ? value.filter((item): item is string => typeof item === 'string')
    : undefined;
}
